import { withCardEvaluation } from '../game/cardPower';
import type { FactionId, GameContext, GameState } from '../game/types';
import { advantage } from './search';

/**
 * How far over even (0.5) the AI still counts itself level: a position this close is a draw in
 * all but the decimals, and one side is not ahead in it.
 */
export const DRAW_LEVEL_MARGIN = 0.02;

/**
 * Whether the AI playing `faction` accepts a draw it is offered (D-46): only when it judges it is
 * not ahead, by the reading the sign's balance bar shows (`advantage`), with Card fights weighed
 * as the AI weighs them when it plays.
 */
export function acceptsDraw(ctx: GameContext, state: GameState, faction: FactionId): boolean {
  if (state.phase === 'ended') return false;
  const judged = ctx.combatMode === 'card' ? withCardEvaluation(ctx) : ctx;
  return advantage(judged, state, faction) <= 0.5 + DRAW_LEVEL_MARGIN;
}
